import styled from 'styled-components';

const TextLink = styled.a`
  color: #1e58ed;
  padding-left: 0;
  text-decoration: none;
`;

const SmallButton = styled.button<{ isActive?: boolean }>`
  background-color: inherit;
  color: inherit;
  border: none;
  border-radius: 8px;
  padding: 6px 10px;

  ${({ isActive }) =>
    isActive &&
    `
    background-color: #1D4586;
    color: #ffffff;
  `}
`;

const HeaderTextLayout = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HeaderLayout = styled.div`
  margin: 24px 0;
`;

const HeaderText = styled.div`
  font-size: 24px;
  font-weight: 500px;
`;

const SubheaderText = styled.div`
  font-size: 18px;
  font-weight: 600px;
`;

const PageHeader = styled.div`
  color: white;
  font-size: 18px;
  background: #098b8c;
  padding: 8px 24px;
`;

const PageLayout = styled.div`
  margin: 0;
`;

const ClientTaskManagerLayout = styled.div`
  overflow: scroll;
  margin: 0;
`;

export {
  TextLink,
  HeaderLayout,
  PageHeader,
  PageLayout,
  HeaderText,
  SmallButton,
  SubheaderText,
  HeaderTextLayout,
  ClientTaskManagerLayout,
};
